module.exports = __webpack_public_path__ + "img/chd-bg-2.82a13b95.png";